import { InjectionToken } from "@angular/core";
import { CwtAppConfig } from "./core-app.config";

export const CWT_CAPTCHA_CONFIG = new InjectionToken<CwtAppConfig>('cwt-captcha-config');

export interface CwtCaptchaConfig {
    siteKey: string;
}
